import React from 'react'
import { useTranslation } from 'react-i18next'
import { LightBulbIcon, FlagIcon, MapIcon, CheckBadgeIcon } from '@heroicons/react/24/outline'
import CountUpStat from '../Elements/CountUpStat'

const valuesData = [
  {
    key: 'mission',
    icon: LightBulbIcon,
  },
  {
    key: 'vision',
    icon: FlagIcon,
  },
]

const badgesData = [
  { key: 'nationalPresence', icon: MapIcon },
  { key: 'qualityCertifications', icon: CheckBadgeIcon },
]

export default function AboutUsPage() {
  const { t } = useTranslation('aboutUs')

  return (
    <div>
      {/* Hero + Misión/Visión, una sola sección */}
      <div className="min-h-screen overflow-x-hidden bg-gray-50">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
          <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-7 lg:min-h-[36rem]">
            <div className="lg:col-span-3">
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-white px-4 py-1.5 text-sm font-medium text-electric-700 shadow-sm">
                {t('hero.eyebrow')}
              </span>
              <h1 className="mt-6 text-4xl font-bold tracking-tight text-navy-900 sm:text-5xl">
                {t('hero.heading')}
              </h1>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                {t('hero.paragraph1')}
              </p>
              <p className="mt-4 text-lg leading-8 text-gray-600">
                {t('hero.paragraph2')}
              </p>

              <dl className="mt-12 grid grid-cols-2 gap-6 border-t border-gray-200 pt-8 sm:grid-cols-4">
                <CountUpStat
                  target={100}
                  suffix="%"
                  label={t('stats.mexican')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
                <CountUpStat
                  target={26}
                  suffix="+"
                  label={t('stats.experience')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
                <CountUpStat
                  target={27400}
                  suffix="+"
                  label={t('stats.equipmentInstalled')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
                <CountUpStat
                  target={450}
                  suffix="+"
                  label={t('stats.recognizedCompanies')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
              </dl>

              <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
                {badgesData.map((badge) => (
                  <div key={badge.key} className="flex items-center gap-2 text-sm font-medium text-gray-600">
                    <badge.icon className="h-5 w-5 text-electric-600" aria-hidden="true" />
                    {t(`badges.${badge.key}`)}
                  </div>
                ))}
              </div>
            </div>

            <div className="relative hidden self-stretch lg:col-span-4 lg:block lg:translate-x-20 xl:translate-x-32">
              <img
                src="/vt.png"
                alt={t('hero.imageAlt')}
                className="h-full w-full object-contain object-right"
                // style={{
                //   maskImage: 'radial-gradient(circle, black 50%, transparent 80%)',
                //   WebkitMaskImage: 'radial-gradient(circle, black 50%, transparent 80%)',
                // }}
              />
            </div>
          </div>

          {/* MISIÓN / VISIÓN */}
          <div className="mt-20 border-t border-gray-200 pt-16">
            <h2 className="text-sm font-semibold uppercase tracking-wide text-electric-600">{t('values.eyebrow')}</h2>
            <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2">
              {valuesData.map((value) => (
                <div key={value.key} className="rounded-2xl border border-gray-200 bg-white p-6">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-navy-900">
                    <value.icon className="h-5 w-5 text-white" aria-hidden="true" />
                  </div>
                  <h3 className="mt-4 text-base font-bold text-navy-900">{t(`values.${value.key}.name`)}</h3>
                  <p className="mt-2 text-sm leading-6 text-gray-600">{t(`values.${value.key}.description`)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
